module.exports = new __parcel__URL__("documents-illustration.37d481a2.svg").toString();